(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HotelSheetBuild',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// Initialize the clear button as disabled on load
		$('.room-search-clear-button').prop('disabled', true);

		$('.room-search-input').on('input', function _handleSearchInput() {
			const searchText = $(this).val().trim();
			const $clearButton = $('.room-search-clear-button');
			
			if (searchText.length > 3) {
				$clearButton.prop('disabled', false);
				$clearButton.removeClass('disabled');
				searchRooms(searchText);
			} else {
				$clearButton.prop('disabled', true);
				$clearButton.addClass('disabled');
				$('.table-row').show();
				$('.room-name-details').each(function _removeHighlights() {
					$(this).html($(this).html().replace(/<mark class="search-highlight">(.*?)<\/mark>/g, '$1'));
				});
			}
		});

		$('.room-search-clear-button').on('click', clearSearch);
	};

	function searchRooms(searchText)
	{
		const searchRegex = new RegExp('(' + searchText + ')', 'gi');
		let matchFound = false;

		$('.table-row').each(function _processRow() {
			const $row        = $(this);
			const roomName    = $row.data('room-name');
			const roomDetails = $row.data('room-details');

			if (roomName.toLowerCase().includes(searchText.toLowerCase()) || 
				roomDetails.toLowerCase().includes(searchText.toLowerCase())) {
				$row.show();
				
				matchFound         = true;
				const $nameDetails = $row.find('.room-name-details');
				const currentHtml  = $nameDetails.html();
				const cleanHtml    = currentHtml.replace(/<mark class="search-highlight">(.*?)<\/mark>/g, '$1');

				$nameDetails.html(cleanHtml.replace(searchRegex, '<mark class="search-highlight">$1</mark>'));
			} else {
				$row.hide();
			}
		});

		// Remove existing notice if present
		$('.no-results-notice').remove();
		
		// Add notice if no matches found
		if (!matchFound) {
			$('.room-search-results').append('<div class="no-results-notice">No rooms match the search term "' + searchText + '"</div>');
		}
	}

	function clearSearch()
	{
		$('.room-search-input').val('');
		$('.room-search-clear-button').prop('disabled', true);
		$('.table-row').show();
		$('.no-results-notice').remove();  // Remove notice when clearing
		$('.room-name-details').each(function _removeHighlights() {
			$(this).html($(this).html().replace(/<mark class="search-highlight">(.*?)<\/mark>/g, '$1'));
		});
	}
}(jQuery, window.Adzuki || {}));
